<template>
  <div :class="['login',locale=='HE' ? 'rtl':'']"
    @transitionend="wrapAnimationEnded"
    @webkittransitionend="wrapAnimationEnded"
  >
    <div
      class="flip-face circle"
      :class="[
        contentWrapAppear ? 'content-wrap-appear' : '',
        introAppear ? 'intro-appear' : ''
      ]"
    >
      <div class="intro" v-if="mode === 'intro'">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          ref="intro-logo"
          :class="[
            'intro-logo',
            introLogoStartReady ? 'anim-start' : '',
            introLogoAnimationEnded ? 'anim-end' : ''
          ]"
          @transitionend="logoAnimationEnded"
          viewBox="0 0 136.06589 64.81544"
        >
          <path
            class="a"
            d="M94.793,35.20126l-27.00577.006V32.50408H94.734a4.67082,4.67082,0,0,0,4.82563-4.3969,4.58559,4.58559,0,0,0-3.82211-4.34106c-.66175-.16352-1.3202-.27838-2.18042-.42442,0,0-1.99937-.20508-7.38937-.86078-4.42528-.47578-6.68337-.67922-12.31344-1.39451a16.84391,16.84391,0,0,1-2.22029-.38388,7.3053,7.3053,0,0,1-2.83993-1.342,3.27741,3.27741,0,0,1-1.16542-3.01655,4.45665,4.45665,0,0,1,4.38268-4.52268h10.0483v2.72345c-3.68267,0-5.50105-.01534-9.44345,0a1.84831,1.84831,0,0,0-1.87577,1.80959,1.63873,1.63873,0,0,0,1.16754,1.60725c.682.24063,3.41908.54035,4.42316.69894.74754.12409,9.8317,1.15444,9.8317,1.15444s8.89492,1.08119,9.54626,1.18289c3.97908.47247,6.743,3.37747,6.743,7.08528a7.24431,7.24431,0,0,1-7.36971,7.11161l-.28711-.00661Z"
          />
          <path
            class="a"
            d="M94.793,35.20126l-27.00577.006V32.50408H94.734a4.67082,4.67082,0,0,0,4.82563-4.3969,4.58559,4.58559,0,0,0-3.82211-4.34106c-.66175-.16352-1.3202-.27838-2.18042-.42442,0,0-1.99937-.20508-7.38937-.86078-4.42528-.47578-6.68337-.67922-12.31344-1.39451a16.84391,16.84391,0,0,1-2.22029-.38388,7.3053,7.3053,0,0,1-2.83993-1.342,3.27741,3.27741,0,0,1-1.16542-3.01655,4.45665,4.45665,0,0,1,4.38268-4.52268h10.0483v2.72345c-3.68267,0-5.50105-.01534-9.44345,0a1.84831,1.84831,0,0,0-1.87577,1.80959,1.63873,1.63873,0,0,0,1.16754,1.60725c.682.24063,3.41908.54035,4.42316.69894.74754.12409,9.8317,1.15444,9.8317,1.15444s8.89492,1.08119,9.54626,1.18289c3.97908.47247,6.743,3.37747,6.743,7.08528a7.24431,7.24431,0,0,1-7.36971,7.11161l-.28711-.00661Z"
          />
          <path class="a" d="M63.16121,0V8.95619H60.43833V0Z" />
          <path class="a" d="M60.42573,11.89619h2.73548V35.37951H60.42573Z" />
          <path
            class="a"
            d="M38.2341,35.4457l-2.765.00493V15.97478a1.63963,1.63963,0,0,0-.63823-1.42189,1.8004,1.8004,0,0,0-1.07733-.286c-.51408.024-.88485,0-1.71718,1.284L20.43551,35.4457l-3.32774-.00436,2.80548-4.8776C20.9791,29.29444,28.713,15.55092,28.713,15.55092c1.46838-2.37014,2.56648-3.70339,4.31267-3.79148a7.73478,7.73478,0,0,1,1.56683,0,4.03763,4.03763,0,0,1,3.121,2.14542A3.83118,3.83118,0,0,1,38.227,15.8331c.04049,6.25957.02514,8.53732.01422,13.9869C40.27614,26.6569,46.528,15.55092,46.528,15.55092c1.46563-2.37014,2.56486-3.699,4.31267-3.79148a7.71823,7.71823,0,0,1,1.56515,0,4.05219,4.05219,0,0,1,3.12267,2.14542,3.85041,3.85041,0,0,1,.5157,1.92824c.0476,7.62345-.006,11.923-.006,19.54641H53.28192V15.97422a1.64734,1.64734,0,0,0-.63549-1.42133,1.84169,1.84169,0,0,0-1.08226-.286c-.50915.024-.88211,0-1.71169,1.284Z"
          />
          <path
            class="tradem b"
            d="M85.66682,10.96444a2.34919,2.34919,0,0,1,1.12656.2964,2.101,2.101,0,0,1,.85641.84711,2.30083,2.30083,0,0,1,.00437,2.28813,2.13325,2.13325,0,0,1-.84711.84875,2.3044,2.3044,0,0,1-2.28047,0,2.14083,2.14083,0,0,1-.84875-.84875,2.29368,2.29368,0,0,1,.00438-2.28813,2.11155,2.11155,0,0,1,.85805-.84711A2.34919,2.34919,0,0,1,85.66682,10.96444Zm0,.37953a1.94921,1.94921,0,0,0-.94008.24773,1.77322,1.77322,0,0,0-.71476.70766,1.90582,1.90582,0,0,0-.00493,1.907,1.80018,1.80018,0,0,0,.7093.70711,1.907,1.907,0,0,0,1.90094,0,1.79253,1.79253,0,0,0,.70765-.70711A1.91292,1.91292,0,0,0,87.32,12.29936a1.76325,1.76325,0,0,0-.71476-.70766A1.95256,1.95256,0,0,0,85.66682,11.344ZM84.66166,14.5235V12.05764h.84711a2.0774,2.0774,0,0,1,.62891.06836.61168.61168,0,0,1,.30953.23844.63139.63139,0,0,1,.11539.36148.6565.6565,0,0,1-.193.47031.75884.75884,0,0,1-.51132.22477.68359.68359,0,0,1,.20945.1307,2.85045,2.85045,0,0,1,.36422.48891l.30078.48289h-.48617l-.21821-.38883a1.98837,1.98837,0,0,0-.41617-.57367.51039.51039,0,0,0-.31883-.08531h-.23406V14.5235Zm.39758-1.388h.48289a.78383.78383,0,0,0,.4725-.10281.33714.33714,0,0,0,.12578-.27344.33234.33234,0,0,0-.0607-.19578.3617.3617,0,0,0-.16844-.12906,1.248,1.248,0,0,0-.39922-.04266h-.45281Z"
          />
          <path
            class="c"
            d="M36.91508,45.08c-.10427-.97032-.25653-1.28378-.726-1.59817a1.7909,1.7909,0,0,0-1.11338-.22837c-.51647.02141-.89613,0-1.73986,1.30891l-11.82952,20.253h-2.8146V44.98694a1.67888,1.67888,0,0,0-.65018-1.449,1.89883,1.89883,0,0,0-1.09932-.28981c-.52294.02459-.89723,0-1.74414,1.31214L3.3878,64.81325H0l11.81348-20.253c1.49391-2.41463,2.61251-3.77276,4.38982-3.86365a7.70317,7.70317,0,0,1,1.5934,0A4.14541,4.14541,0,0,1,20.976,42.88029a3.91727,3.91727,0,0,1,.52508,1.9644c.04172,6.37142.02349,8.68766.01068,14.24311,2.07352-3.2231,8.43635-14.52541,8.43635-14.52541,1.496-2.41677,2.61141-3.77276,4.38982-3.86365a4.75156,4.75156,0,0,1,1.24468.00576c.94217.11121,1.36741.83483,1.33889,1.85063"
          />
          <path
            class="b"
            d="M36.92145,64.53169V42.55513a1.81627,1.81627,0,0,0-.56152-1.54395H52.2945v2.41211l-12.78711.09815v7.94287h6.00879v2.24414H39.50739V64.53169Z"
          />
          <path
            class="a"
            d="M80.4986,64.81392a11.21623,11.21623,0,0,1-5.95117-1.60352,10.36392,10.36392,0,0,1-3.96485-4.37451,13.38408,13.38408,0,0,1-1.35644-5.898c0-3.90967,1.06152-7.0083,3.15332-9.20947a10.77178,10.77178,0,0,1,8.13574-3.30908,11.37532,11.37532,0,0,1,5.88965,1.55566,10.21339,10.21339,0,0,1,3.9873,4.3335A14.226,14.226,0,0,1,91.772,52.65718a13.99177,13.99177,0,0,1-1.45215,6.436A9.89744,9.89744,0,0,1,86.232,63.35933,11.80548,11.80548,0,0,1,80.4986,64.81392Zm.0332-22.1958a8.48582,8.48582,0,0,0-6.03223,2.40381c-1.68066,1.59912-2.5332,4.28173-2.5332,7.97314a9.96057,9.96057,0,0,0,2.42285,7.05664,8.47686,8.47686,0,0,0,12.23828-.02685c1.59571-1.73243,2.4043-4.21436,2.4043-7.37549a12.6641,12.6641,0,0,0-1.02148-5.25391,7.95663,7.95663,0,0,0-3.02149-3.52539A8.22592,8.22592,0,0,0,80.5318,42.61812Z"
          />
          <path
            class="a"
            d="M55.481,64.62984V41.01118h2.64355V62.36031H70.01715v2.26953Z"
          />
          <path
            class="b"
            d="M118.34528,64.74849a4.28326,4.28326,0,0,1-.58594-.042c-.0918-.0127-.1748-.02784-.25684-.044a3.24581,3.24581,0,0,1-1.52246-.77978,4.06385,4.06385,0,0,1-1.0664-1.47852,3.54739,3.54739,0,0,1-.29688-.88623,5.41011,5.41011,0,0,1-.1123-.99072c-.02246-4.17823-.0166-11.57959-.00977-16.02442a1.30982,1.30982,0,0,0-.44433-.7622,1.32883,1.32883,0,0,0-.81543-.26758l-.10254.00342c-.43555.02-.67188.10254-1.12793.8081L105.19,57.75972l-1.47168,2.92969-.123.23242-.07031.12012c-1.28711,2.36084-2.21778,3.57568-3.73536,3.665l-.26953.01758c-.19433.01319-.35742.02393-.52832.02393a4.29415,4.29415,0,0,1-.58594-.042,3.19129,3.19129,0,0,1-1.77929-.82373A3.87789,3.87789,0,0,1,95.6109,62.5063a4.43176,4.43176,0,0,1-.46-1.97949c-.00879-1.53125-.01367-14.72217-.01465-19.51563H97.732l.00683,19.375a1.72175,1.72175,0,0,0,.52246,1.35889,1.33407,1.33407,0,0,0,.81641.26709l.10156-.00342c.4834-.022.77539-.15039,1.38281-1.23095l8.125-16.14893c1.33692-2.48047,2.29786-3.76025,3.835-3.8501l.26953-.01758c.19336-.01318.3623-.022.53027-.022a4.28328,4.28328,0,0,1,.585.04c.09082.0127.17481.02783.25684.044a3.23267,3.23267,0,0,1,1.52246.77978,4.07549,4.07549,0,0,1,1.06836,1.48389,3.73859,3.73859,0,0,1,.2998.916,5.12326,5.12326,0,0,1,.10645.95508c.02344,4.17822.0166,11.58008.01074,16.0249a1.30015,1.30015,0,0,0,.44238.76221,1.33407,1.33407,0,0,0,.81641.26709l.10254-.00342c.4834-.022.77539-.15088,1.38281-1.23095l8.125-16.14893c1.33594-2.48047,2.298-3.74163,3.835-3.8501a3.83414,3.83414,0,0,1,3.16309.82422c1.13713,1.145,1.13965,2.22608.90234,2.58984a1.28855,1.28855,0,0,1-1.05859.59082,1.74524,1.74524,0,0,1-.28223.00733c-1.04067-.19412-.41276-1.65924-1.73834-1.69412,0,0-.66279-.10465-1.50482,1.18728l-6.81348,13.47559-1.48926,2.96338-.10351.19531-.07325.12354c-1.28613,2.36084-2.21679,3.57568-3.73437,3.665l-.26953.01758C118.67829,64.73775,118.51618,64.74849,118.34528,64.74849Z"
          />
        </svg>
        <p
          class="slogan"
          :class="[introLogoAnimationEnded ? 'anim' : '']"
          @transitionend="sloganAnimationEnded"
        >
          MIS MCENTER ORDER SYSTEM
        </p>
      </div>
    </div>
    <div
      class="flip-back circle flex align-center justify-center"
      ref="content"
      :class="[
        contentWrapAppear ? 'content-wrap-appear' : '',
        contentMaskAppear ? 'content-mask-appear' : '',
        //contentAppear ? 'content-appear' : '',
        introAppear ? 'intro-appear' : '',
        switchModeStart
          ? 'switch-mode__start'
          : switchModeEnd
          ? 'switch-mode__end'
          : ''
      ]"
      @transitionend="flipBackAnimationEnded"
    >
      <span class="mask-bounce"></span>

      <div v-if="mode !== 'intro' && contentAppear" class="form-wrap">
        <!-- :class="[!resetSent ? 'px-xl' : '']" -->
        <div v-if="resetSent" class="container tcenter text-green-2 py-2xl">
          <i class="fal fa-paper-plane fa-3x"></i>
          <h3 class="text-green-3 my-xl">
            An email has been sent to reset your password
          </h3>
          <h3>
            please click the<br />
            <strong class="underline">reset link</strong>
          </h3>
        </div>

        <template v-else>
          <h4
            :class="[
              'login-title',
              'mb-l',
              $device === 'mobile' ? 'ml-s' : 'ml-m',
              'font-rg'
            ]"
            v-text="loginTitle"
          ></h4>
          <div class="form">
            <transition-group
              class="form-part--fields"
              tag="div"
              name="fade-slide"
              mode="out-in"
              appear
            >
              <form-field
                :class="$device === 'mobile' ? 'mb-s' : 'mb-l'"
                v-if="mode !== 'reset'"
                field-type="email"
                v-model="username"
                :validation="emailRx"
                :err="!emailRx.test(username)"
                :valid="emailRx.test(username)"
                err-msg="Please enter valid email"
                :dirty="hasBeenSubmitted"
                :trigger-validation="validateTrig"
                @validate-field="updateValidHash"
                @keyup.native.enter="submit"
                key="email"
                v-bind:label="localize('user_name')"
                label-is-placeholder
                valid-icon
                external-label
                req
                rounded
                fat
              ></form-field>
              <form-field
                class="mb-xs"
                key="psw"
                v-if="mode !== 'forgot'"
                field-type="password"
                v-bind:label="localize('password')"
                label-is-placeholder
                v-model="password"
                :err-msg="'Field is required'"
                valid-icon
                :external-label="mode !== 'reset'"
                :dirty="hasBeenSubmitted"
                @validate-field="updateValidHash"
                @remove-validation="removeFromValidHash"
                req
                @keyup.native.enter="submit"
                rounded
                fat
              >
                <password-meter
                  v-if="mode === 'reset'"
                  slot="pswmeter"
                  :password="password"
                />
              </form-field>
              <form-field
                class="mb-xs"
                key="pswConfirm"
                v-if="mode === 'reset'"
                field-type="password"
                v-bind:label="localize('confirm_password')"
                v-model="passConfirm"
                :err="!!password && password !== passConfirm"
                :valid="!!password && password === passConfirm"
                @remove-validation="removeFromValidHash"
                :err-msg="
                  passConfirm ? `Password doesn't match` : 'Field is required'
                "
                :disabled="!password"
                valid-icon
                :dirty="hasBeenSubmitted"
                @validate-field="updateValidHash"
                req
                fat
              ></form-field>
              <p
                key="resetNote"
                v-if="loginNote"
                class="note"
                v-text="loginNote"
              ></p>
              <div
                class="err text-red-4 pt-s pb-m pl-m note"
                v-if="err"
                v-text="err"
                key="err"
              ></div>
              <!-- <transition mode="out-in" name="fade-appear" appear> -->
              <div
                v-if="mode === 'login'"
                class="action-bar flex align-center justify-between"
                key="login"
              >
                <a
                  @click.prevent="mode = mode === 'login' ? 'forgot' : 'login'"
                  class="forgot-link text-gray-7 flex-none mt-xs"
                  :class="$device === 'mobile' ? 'ml-s' : 'ml-m'"
                  href="#forgot"
                >
                  <span
                    v-text="
                      mode === 'forgot'
                        ? this.localize('oh_wait') 
                        : this.localize('forgot_password') 
                    "
                  ></span>
                </a>
              </div>
            </transition-group>
            <!-- </transition> -->
            <button @click="submit" class="enter-btn mx-auto mb-m mt-l">
              <span class="mr-s" v-text="loginBtnLabel"></span>
              <preloader
                v-if="sendingToServer"
                inline
                color="white"
              ></preloader>
              <!-- <i v-else class="fal fa-chevron-right"></i> -->
            </button>
            <span v-if="mode !== 'reset'" class="block tcenter note flex-none">
              <span class="text-gray-7">{{localize('new_member')}}?</span>
              <router-link class="flex-none mx-xs" to="/register"
                >{{localize('sign_up')}}</router-link
              >
            </span>

            <transition name="fade-appear" appear>
              <router-link
                v-if="mode !== 'login'"
                class="block mt-2xl note mx-auto tcenter"
                :to="{ name: 'Login' }"
                replace
                @click.native="backToLogin"
              >
                <span>{{localize('back_to_login')}}</span>
                <i class="fas fa-chevron-right fa-xs ml-xs"></i>
              </router-link>
            </transition>
          </div>
        </template>
      </div>
    </div>
    <a
      class="privacy-link"
      target="_blank"
      href="https://www.mis-implants.com/home/Privacy-Policy"
      >{{localize('privacy_policy')}}</a
    >
  </div>
</template>
<script>
import PasswordMeter from "vue-simple-password-meter";

import { storage } from "@/utils";

import { mapActions, mapState } from "vuex";
export default {
  name: "Login",
  data() {
    return {
      PasswordLbl:'ddd',
      err: null,
      validateTrig: -1,
      username: null,
      password: null,
      passConfirm: null,
      remember: false,
      resetSent: false,
      // MODES
      mode: "intro",
      contentAppear: false,
      contentWrapAppear: false,
      contentMaskReady: false,
      contentMaskAppear: false,
      switchModeStart: false,
      switchModeEnd: false,
      // INTRO
      introAppear: false,
      introLogoStartReady: false,
      introLogoAnimationEnded: false
    };
  },
  mounted() {
    // console.log("! initIntro >> ", this.mode);
    if (this.mode == "intro") {
      // this.$nextTick(function() {
      setTimeout(
        function() {
          // console.log("initIntro!");
          this.initIntro();
        }.bind(this),
        600
      );
      // });
    } else {
      // console.log("skipIntro!");
      this.skipIntro();
    }
    console.log("this.requestedPath: ", this.requestedPath);
    if (this.requestedPath && !/^\/(login)?$/.test(this.requestedPath)) {
      this.$toasted.show("You need to sign in before you proceed", {
        position: "top-center",
        // iconPack: "fontawesome",
        type: "warning",
        theme: "bubble",
        icon: {
          name: "fal fa-exclamation-circle mr-xs"
        }
      });
    }
  },
  watch: {
    mode() {
      console.log("mode changed: ", this.mode);

      // HIDE CONTENT
      this.contentAppear = false;

      // START THE MASK ANIMATION (scale(0))
      this.contentMaskAppear = false;

      setTimeout(
        function() {
          this.contentMaskAppear = true;
        }.bind(this),
        800
      );
      // this.switchModeStart = true;
      this.password = null;
      this.err = null;

      // if (mode==='forgot') {
      // }
    }
  },
  components: {
    PasswordMeter
  },
  created() {
    // let q = this.$route.query;
    let path = this.$route.path;
    if (path.indexOf("reset") > -1) {
      if (this.token) {
        // this.reset = true;
        this.mode = "reset";
      }
    }
    // console.log("query > ", this.$route.query);
  },
  methods: {
    ...mapActions(["initUser", "updateShowTopBar"]),
    logoAnimationEnded: _.debounce(
      function() {
        // console.log("logoAnimationEnded: ", a, b, c);
        this.introLogoAnimationEnded = true;
      },
      50,
      true
    ),

    // .flip-back circle,
    // Contain all sign-in elements except the intro...
    flipBackAnimationEnded(e) {
      // console.log('flipBackAnimationEnded: ',e);
      if (this.mode === "intro") {
        // this.contentMaskAppear = true;
        this.mode = "login";
        this.$nextTick(function() {
          setTimeout(
            function() {
              this.updateShowTopBar(true);
            }.bind(this),
            600
          );
        });
      } else if (
        (e.pseudoElement || e.target.className.indexOf("mask") > -1) &&
        this.contentMaskAppear
      ) {
        // THE CONTENT MASK ANIMATION HAS ENDED
        this.contentAppear = true;
      }
    },
    skipIntro() {
      this.contentWrapAppear = true;
    },
    initIntro() {
      // console.log("initIntro: ");
      let logo = this.$refs["intro-logo"];
      let paths = logo.querySelectorAll("path");
      let lengths = _.map(paths, c => c.getTotalLength());
      _.forEach(paths, (p, i) => {
        p.setAttribute("stroke-dasharray", lengths[i]);
        p.setAttribute("stroke-dashoffset", lengths[i]);
      });
      this.introAppear = true;
    },
    sloganAnimationEnded() {
      // console.log("sloganAnimationEnded");
      setTimeout(
        function() {
          this.contentWrapAppear = true;
        }.bind(this),
        50
      );
    },
    wrapAnimationEnded(e) {
      // console.log("wrapAnimationEnded", e);
      let logo = this.$refs["intro-logo"];
      if (logo) {
        let paths = logo.querySelectorAll("path");
        this.introLogoStartReady = true;
        _.forEach(paths, (p, i) => {
          p.setAttribute("stroke-dashoffset", 0);
        });
      }
    },
    backToLogin() {
      this.mode = "login";
      // this.reset = false;
      // this.forgot = false;
    },
    async sendtoServer(method, mode, cache, headers, body) {
      // console.log("Send to server >>>> ", body);
      return fetch(this.api, {
        method,
        mode,
        cache,
        headers,
        body
      })
        .then(function(response) {
          return response.json();
        })
        .then(function(res) {
          // vm.sendingToServer = false;
          console.log("back from server >>>> ", res);
          if (res === "ok") {
            return true;
          } else if (res.userID) {
            // login success
            return res;
          }
          //  else {
          //   return"Something went wrong. Please try again.";

          // }
          return false;
        })
        .catch(err => err);
    },
    async submit() {
      this.hasBeenSubmitted = true;
      this.err = null;
      this.$nextTick(async function() {
        if (this.formIsValid) {
          console.log("FORM IS VALID");
          this.sendingToServer = true;
          let method = "post",
            mode = "cors",
            cache = "no-cache",
            headers = {
              "pragma": "no-cache",
              "cache-control": "No-Store",
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*"
            };
          if (this.mode === "reset") {
            let body = JSON.stringify({
              uid: this.tokenUserId,
              e: this.tokenEmail,
              p: this.password,
              t: this.token
            });
            let res = await this.sendtoServer(
              method,
              mode,
              cache,
              headers,
              body
            );
            console.log("rsponse from server to reset: ", res);
            if (res) {
              // this.reset = false;
              this.mode = "login";
              this.hasBeenSubmitted = false;
              this.$toasted.show("Password has been reset", {
                iconPack: "fontawesome",
                type: "success",
                theme: "bubble",
                icon: "check"
              });
              this.$router.push("/login");
            } else {
              this.err = "Something went wrong. Please try again.";

              this.hasBeenSubmitted = false;
            }
          } else if (this.mode === "forgot") {
            let res = await this.sendtoServer(method, mode, cache, headers);
            console.log("rsponse from server to forgot: ", res);

            if (res) {
              // this.forgot = false;
              this.resetSent = true;
            }
          } else {
            // LOGIN
            let res = await this.sendtoServer(method, mode, cache, headers);
            console.log("rsponse from server to login: ", res);
            if (res && !/error/gi.test(res)) {
              // if (this.remember) {
              //   }
              storage.set(`MFLOW__userData`, res, localStorage);
              this.initUser(res);
              if (this.requestedPath && this.requestedPath !== "/") {
                this.$router.push(this.requestedPath);
              } else {
                this.$router.push("/");
              }
            } else if (res) {
              this.err = res;
            } else {
              this.err = "Email or password do not match an account.";
            }
          }
          this.sendingToServer = false;
        } else {
          console.log("FORM IS INVALID< ", this.formIsValid);
        }
      });
    }
  },
  computed: {
    ...mapState(["requestedPath", "$device","locale"]),
    // mode() {
    //   return this.forgot
    //     ? "forgot"
    //     : this.reset
    //     ? "reset"
    //     : this.login
    //     ? "login"
    //     : "intro";
    // },
    token() {
      return this.$route.query.t;
    },
    tokenUserId() {
      return this.$route.query.uid;
    },
    tokenEmail() {
      return this.$route.query.e;
    },
    loginTitle() {
      return this.mode === "forgot"
        ? this.localize('retrieve_password')
        : this.mode === "reset"
        ? this.localize('password_reset')
        : this.localize('sign_me_in');
    },
    loginNote() {
      return this.mode === "forgot"
        ? this.localize('please_enter_the_email')
        : this.mode === "reset"
        ? this.localize('please_enter_new_password_for_account')
        : null;
    },
    loginBtnLabel() {
      let label;
      switch (this.mode) {
        case "forgot":
          label = this.localize('renew_password');
          break;
        case "reset":
          label = this.localize('reset_password');//"Reset Password";
          break;
        default:
          label = this.localize("sign_me_in");// "Sign me in";
          break;
      }
      return label;
    },
    api_signin() {
      return SERVER_API[ENV] + "mflow/SignIn";
    },
    api_forgot() {
      return SERVER_API[ENV] + "mflow/UserResetPass";
    },
    api_reset() {
      return SERVER_API[ENV] + "mflow/UserResetNewPass";
    },
    api() {
      let api;
      switch (this.mode) {
        case "forgot":
          api = `${this.api_forgot}?e=${this.username}`;
          break;
        case "reset":
          api = this.api_reset;
          break;
        default:
          // LOGIN
          api = `${this.api_signin}?u=${this.username}&p=${this.password}`;
          break;
      }
      return api;
    }
  }
};
</script>

<style>
  .login.rtl .form-part--field .icon-wrap
  {
      right:initial;
      left:0.625rem;
  }
</style>

<style lang="stylus">
.intro-logo
  z-index 999
  transform translateZ(0)
  -webkit-transform-style preserve-3d
  transform-style preserve-3d
  *
    fill transparent
  path
    will-change stroke-dashoffset, fill, opacity
  &.anim-start
    // background green
    path
      transition stroke-dashoffset 1.5s ease-out
      stroke #fff
      &.tradem
        opacity 0
  &.anim-end
    // background red
    path
      transition stroke 0.4s ease-in, fill 0.6s ease-out, opacity 0.3s ease-out
      &.tradem
        opacity 1
    .a
    .b
      fill #fff
      stroke rgba(#fff, 0)
    .a
      fill-rule evenodd
    .c
      fill #00c4b3
      stroke transparent
    .d
      fill #008790
      stroke transparent
.login
  .circle
    round(533)
    center()
    background blue_brand
    top 55%
    transform translate(-50%, -50%)
    opacity 0
    will-change transform, opacity
    transform-style preserve-3d
    -webkit-transform-style preserve-3d
    transition opacity 0.6s ease-out, transform 1s ease-out-quint
    +below(1400px)
      round(480)
    +below(815px)
      round(400)
      top 50%

    &.flip-face
      transform translate(-50%, 80%) scale(0)
      &.intro-appear
        opacity 1
        transform translate(-50%, -50%) scale(1)
      &.content-wrap-appear
        transition opacity 0.6s ease-out, transform 1s ease-in-out-back
        transform translate(-50%, -50%) rotateY(-180deg)
        // backface-visibility hidden
        .intro-logo
        .slogan
          visibility hidden
          opacity 0
          display none
          backface-visibility hidden
    &.flip-back
      transition opacity 0.6s ease-out, transform 1s ease-in-out-back

      // transition opacity 0.6s ease-out, transform 1s ease-in-out-back
      .mask-bounce
      &:after
        // content ''
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
        background #fff
        width 0px
        height 0px
        border-radius 100%
        will-change width, height
        transition width 0.3s ease-in-out-quint, height 0.3s ease-in-out-quint
      &.content-wrap-appear
        background green_4
        opacity 1
        transform translate(-50%,-50%) rotateY(180deg)
      &.content-mask-appear
        .mask-bounce
        &:after
          transition width 0.3s ease-in-out-quint, height 0.3s ease-in-out-quint
          // transition transform 0.4s ease-in-out-quint
          // transform translate(-50%, -50%) scale(0.99)
          width 99%
          height 99%
          z-index -1
      &.switch-mode__start
        .mask-bounce
        &:after
          background blue_brand
          transform translate(-50%, -50%)
          width 0px
          height 0px
      &.switch-mode__end
        .mask-bounce
        &:after
          // transform translate(-50%, -50%) scale(0.99)
          width 99%
          height 99%

    .form-wrap
      padding 120px calc(533px / 5)
      transform translateY(5%) scale(-1, 1)
      transform-style preserve-3d
      +below(815px)
        padding 60px calc(300px / 5)

    .login-title
      text-transform uppercase
      font-size 20px
  .intro
    position absolute
    top 55%
    left 50%
    transform translate(-50%,-50%)
    width 75%
    +below(815px)
      top 50%
    .slogan
      color #fff
      font-size 18px
      font-weight 300
      letter-spacing 2px
      position relative
      overflow hidden
      +below(815px)
        font-size 14px
        letter-spacing 1px
      &:before
        content ''
        position absolute
        top 0
        left 0
        width 130%
        height 100%
        background linear-gradient(to right, rgba(blue_brand, 0) 0%, rgba(blue_brand, 1) 15%)
        transform translateX(-20%)
        transition transform 1.5s 0.4s ease-out-quad
      &.anim:before
        transform translateX(100%)
.forgot-link
  font-size 14px
.enter-btn
  _flex(row, wrap, center, center)
  background blue_brand
  height 48px
  font-size 16px
  min-width 100px
  padding 0 24px
  border none
  border-radius 24px
  outline 0
  color #fff
  cursor pointer
  text-transform uppercase
  transition background 0.2s ease-out, box-shadow 0.2s ease-out
  +below(815px)
    height 40px
    padding 0 16px
    border-radius 20px
  &:hover
    background darken(blue_brand, 6)
    box-shadow 2px 2px 4px rgba(0,0,0,0.4)
  span
    line-height 1
    display inline-block
    margin-top -2px
</style>
<style lang="stylus" scoped>
.privacy-link
  position absolute
  bottom 0
  left 50%
  transform translate(-50%, -100%)
</style>
